import React from 'react';
import { BaasicTable } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const ShipmentCostListTemplate = ({ t, viewStore, viewStore: { tableData, queryUtility, loading, data } }) => {
	return (
		<div className="flex--grow--1">
			<BaasicTable
				actions={viewStore}
				data={data != null ? data.slice() : null}
				showLoader={loading}
				{...{ tableData, queryUtility, viewStore }}
			/>
		</div>
	);
};

export default defaultTemplate(ShipmentCostListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/shipment-cost/pages/ShipmentCostListTemplate.jsx